// extracted by mini-css-extract-plugin
module.exports = {"Loader":"_2pG5SLblCA1H48XV93xKiE","load2":"_3_T4ThVO4tL5NBg-iA5aPk"};